<app-comment-list
  [comments]="(comments | async)!"
  [orgaUsers]="(orgaUsers | async)!"
  [loggedInUserId]="(loggedInUserId | async)!"
  (createNewComment)="createNewComment($event)"
  (deleteComment)="deleteComment($event)"
  (markAsReacted)="markAsReacted($event)"
  [padded]="_padded"
></app-comment-list>
